import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { setAiMediaToCompany } from '../../../../redux/customers/customersActions';
import AIMediaFormInner from './AIMediaFormInner';
import arrayToContainerOptions from '../../../ai-features/utils/arrayToContainerOptions';

function AIMediaForm() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const aiMediaTypes = useSelector((state) => state.customers.customerInfo?.aiPlaygroundMediaTypes);

  const initialValues = {
    assignedAIMedia: arrayToContainerOptions(aiMediaTypes),
  };

  const handleChangeAIMedia = async (values) => {
    await dispatch(setAiMediaToCompany({ aiMedia: values.assignedAIMedia, companyId: id }));
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleChangeAIMedia}
      subscription={{
        submitting: true,
        submitFailed: true,
        submitSucceeded: true,
      }}
      render={({ handleSubmit }) => <AIMediaFormInner onSubmit={handleSubmit} />}
    />
  );
}

export default AIMediaForm;
